import { Card, CardContent, CardMedia } from '@material-ui/core';

Card.cardContent = CardContent;
Card.cardMedia = CardMedia;

export default Card;
